import { Box, Grid, Theme, Typography } from "@mui/material";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import React from "react";
import { SubHeading } from "../../investors/components";
import { applicantStatusMasters } from '../../../utils/constant';
import { ViewProfileProps } from "../types";
import { getUniqueIdentityText, isOnboardingTypeMinor } from "../../../utils/utilityFunctions";
import { formatShortDate } from "../../../utils/date";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";

export default function SupportDetails(): JSX.Element {
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container >
                        <Grid item xs={12} >
                            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                                Support Details
                            </Typography>

                        </Grid>
                        <Box>
                            <Typography variant="body_500" color='text.secondary'>Email</Typography>
                            <Typography variant="body_500">support@thriveiti.com</Typography>
                        </Box>
                    </Grid>
                </Box>
            </Box >
        </>
    )
}